import React from "react"
import { Link, useNavigate, useParams } from "react-router-dom"
import { ProgressMeetRepositoryImpl } from "data/repository/Student/ProgressMeetRepositoryImpl"
import ProgressMeetAPIDataSourceImpl from "data/API/Student/ProgressMeetAPIDataSourceImpl"
import { FetchProgressMeetDetails } from "domain/useCase/Student/ProgressMeet/FetchProgressMeetDetails"
import { useAuth } from "core/context/auth"
import { GetAllProgressMeet } from "domain/useCase/Student/ProgressMeet/GetAllProgressMeet"
import useLocalStorage from "core/hooks/useLocalStorage"
export default function RecordedProgressMeetViewModel() {
  const { auth } = useAuth()
  const navigate = useNavigate()
  const { meeting_id }: any = useParams()
  const [meetingId, setMeetingId] = React.useState<any>(() => meeting_id)
  const [loading, setLoading] = React.useState<any>(false)
  const [progressMeetDetails, setProgressMeetDetails] = React.useState<any>({})
  const [allProgressMeet, setAllProgressMeet] = React.useState<any[]>([])
  const [pastSession, setPastSession] = React.useState<any[]>([])
  const [activeIndex, setActiveIndex] = React.useState<any>(-1)
  const [progressMeetList, setProgressMeetList] = useLocalStorage<any>("progress_meet", {})
  const [progressMeet, setProgressMeet] = React.useState<any>(null)

  const fetchProgressMeetDetails = new FetchProgressMeetDetails(
    new ProgressMeetRepositoryImpl(new ProgressMeetAPIDataSourceImpl())
  )
  const getAllProgressMeetsUseCase = new GetAllProgressMeet(
    new ProgressMeetRepositoryImpl(new ProgressMeetAPIDataSourceImpl())
  )
  const fetchProgressMeetDetail = async () => {
    setLoading(true)
    const data: any = await fetchProgressMeetDetails.invoke(auth, meetingId)
    setLoading(false)
    if (data) {
      setProgressMeetDetails(data)
    }
  }
  async function getAllProgressMeets() {
    try {
      const progressMeets = await getAllProgressMeetsUseCase.invoke(auth)
      const sortedProgressMeets = progressMeets?.sort(
        (a, b) => new Date(b.session_timestamp).getTime() - new Date(a.session_timestamp).getTime()
      )

      setAllProgressMeet(sortedProgressMeets || [])
      setProgressMeetList(sortedProgressMeets)
    } catch (error) {
      console.error("Failed to fetch progress meets:", error)

      setAllProgressMeet([])
    }
  }
  const filterSessions = () => {
    const currentDate = new Date()

    const past: any[] = []

    allProgressMeet.forEach((meeting) => {
      const sessionDate = new Date(meeting.session_timestamp * 1000)
      const threeHoursAfterSession = new Date(sessionDate.getTime() + 3 * 60 * 60 * 1000)
      if (sessionDate >= currentDate || threeHoursAfterSession > currentDate) {
      } else {
        past.push(meeting)
      }
    })

    setPastSession(past)
  }
  const formatDate = (timestamp: number): string => {
    const date = new Date(timestamp * 1000)
    const day = date.getDate()
    const month = date.toLocaleString("en-US", { month: "short" })
    const year = date.getFullYear()

    const getOrdinalSuffix = (day: number) => {
      if (day > 3 && day < 21) return "th"
      switch (day % 10) {
        case 1:
          return "st"
        case 2:
          return "nd"
        case 3:
          return "rd"
        default:
          return "th"
      }
    }

    return `${day}${getOrdinalSuffix(day)} ${month} ${year}`
  }

  function onLectureClick(lecture: any, index: number) {
    if (index === activeIndex) return
    setActiveIndex(index)
    setProgressMeet(lecture)
    setMeetingId(lecture?.meeting_id)
    navigate(`/progress-meeting/${lecture?.meeting_id}`)
  }

  return {
    navigate,
    fetchProgressMeetDetail,
    meetingId,
    progressMeetDetails,
    loading,
    formatDate,
    getAllProgressMeets,
    allProgressMeet,
    pastSession,
    filterSessions,
    onLectureClick,
    activeIndex,

    progressMeetList,
  }
}
